import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FaRegCircleXmark } from "react-icons/fa6";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { deleteDataUsers } from "../../../store/slices/authSlice";

const DeleteModalUsers = ({ id }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleDeleteItem = () => {
    dispatch(deleteDataUsers(id));
    handleCloseModal();
  };

  return (
    <div>
      <button className="text-danger mx-1" onClick={handleOpenModal}>
        <FaRegCircleXmark style={{ width: 19, height: 19 }} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
          <div className="bg-black bg-opacity-40 absolute inset-0"></div>

          <div className="relative w-full max-w-sm sm:max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg z-10 overflow-hidden">
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark className="w-5 h-5" />
            </button>

            <div className="p-6 text-center">
              <div className="mx-auto text-gray-400 dark:text-gray-200 mb-4">
                <AiOutlineExclamationCircle className="mx-auto w-16 h-16" />
              </div>

              <h3 className="mb-5 text-base sm:text-lg font-normal text-gray-600 dark:text-gray-300">
                A jeni të sigurt që dëshironi ta fshini?
              </h3>

              <div className="flex flex-col sm:flex-row justify-center items-center gap-3">
                <button
                  type="button"
                  onClick={handleDeleteItem}
                  className="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-300 dark:bg-red-700 dark:hover:bg-red-600 dark:focus:ring-red-500"
                >
                  Po, vazhdo
                </button>

                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-100 hover:text-black rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 dark:bg-gray-600 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-500"
                >
                  Jo, anulo
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteModalUsers;
